<script>
  import GameService from "../services/GameService";

  export default {
    mounted() {
      GameService.join(this.$route.params.gameId, this.$route.params.inviteCode)
        .then(response => {
          this.$router.push({name: "game", params: {gameId: response.data.data.id}});
        })
        .catch(() => {
          this.$router.push({name: "home"});
        });
    },

    render() {
      return null;
    }
  };
</script>